'use client';

import { cn, numberFormatter } from '@/lib/utils';

export function ChangeText({
  value,
  showTriangle = true,
  className,
  suffix = '%',
  digits = 1,
}: {
  value: number;
  showTriangle?: boolean;
  className?: string;
  suffix?: string;
  digits?: number;
}) {
  const index = value > 0 ? 2 : value < 0 ? 1 : 0;
  const sign = ['', '', '+'][index];
  const triangle = showTriangle ? ['', '▼ ', '▲ '][index] : '';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-xs font-semibold leading-none',
        className,
        {
          'text-[#14C784]': index === 2,
          'text-[#FF6B6B]': index === 1,
          'text-[#757575]': index === 0,
        },
      )}
    >
      {triangle}
      {sign}
      {numberFormatter(value, {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      })}
      {suffix}
    </span>
  );
}
